import { Component } from '@angular/core';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../../../Shared/Services/auth.service';
import { DiscountService } from '../../../Services/discount.service';
import { DtoDescountVM } from '../../../Model/discount/DtoDescountVM';
import { SharedService } from '../../../Shared/Services/shared.service';
import { Router } from '@angular/router';
import { UserType } from '../../../Shared/Enums/UserType';

@Component({
  selector: 'app-discount-rate',
  templateUrl: './discount-rate.component.html',
  styleUrl: './discount-rate.component.scss'
})
export class DiscountRateComponent {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  AllDescount!: Record<string, DtoDescountVM[]> | undefined;
  constructor(private api: DiscountService, private auth: AuthService, private spinner: NgxSpinnerService,
    private shared: SharedService,private router: Router) {
  }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.admin])) {
      this.spinner.show();
      this.GetAllDescount();
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetAllDescount() {
    if (this.auth.isAuthenticated([UserType.admin])) {
      this.api.GetAllDescount()
        .pipe(takeUntil(this.destroy$))
        .subscribe((data: any) => {
          const AllDescount = this.shared.groupBy<DtoDescountVM>(data.payload, (p: DtoDescountVM) => p.typeOfDescountName);
          this.AllDescount = AllDescount;
          this.spinner.hide();
        });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }
}
